import React, { Component } from "react";
import { Box } from "reflexbox";
import { CommandBarButton } from "office-ui-fabric-react/lib/Button";
import { CommandBar } from "office-ui-fabric-react/lib/CommandBar";
import { SearchBox } from "office-ui-fabric-react/lib/SearchBox";

import MoveOrderDialog from "../../../common/Forms/_MoveOrderDialog";
import SplitOrderDialog from "../../../common/Forms/_SplitOrderDialog";

import ImportTransitDialog from "../../../common/Forms/_ImportTransitDialog";
import ConfirmDeleteDialog from "../../../common/Forms/_ConfirmDeleteDialog";

import OrderTagButton from "../../../common/Buttons/_OrderTagButton";
import ReportToggleButton from "../../../common/Buttons/_ReportToggleButton";

import ToggleForm from "../../../common/Buttons/_ToggleForm";

import Manifest from "../../Reports/Manifest";
import DriverLoadingList from "../../Reports/DriverLoadingList";

import TransitExelExport from "../../Reports/_TransitExelExport";
import TruckExelExport from "../../Reports/_TruckExelExport";

import ToggleOrderAttachmentDialog from "../../../common/Buttons/_ToggleOrderAttachmentDialog";

class OrdersByShipmentTableCommandBar extends Component {
  _onRenderItem = item => {
    return <div key={item.key}>{item.component} </div>;
  };

  render() {
    return (
      <CommandBar
        items={[
          {
            onRender: this._onRenderItem,
            component: (
              <Box style={{ marginTop: "5px" }}>
                <SearchBox
                  className="searchBox"
                  placeholder="Search"
                  onChange={this.props.handleSearch}
                />
              </Box>
            ),
            key: "item1"
          },
          {
            onRender: this._onRenderItem,
            component: <ToggleForm form="order" addOrEdit="add" />,
            key: "item2"
          },
          {
            onRender: this._onRenderItem,
            component: (
              <ToggleForm
                form="order"
                addOrEdit="edit"
                disabled={this.props.selectedItems.length !== 1}
              />
            ),
            key: "item3"
          },
          {
            onRender: this._onRenderItem,
            component: <ToggleOrderAttachmentDialog buttonType="command" />,
            key: "item4"
          },
          {
            onRender: this._onRenderItem,
            component: (
              <MoveOrderDialog
                text="Move"
                selectedItems={this.props.selectedItems}
              />
            ),
            key: "item5"
          },
          {
            onRender: this._onRenderItem,
            component: (
              <SplitOrderDialog
                text="Split"
                id={
                  this.props.selectedItems.length !== 1
                    ? ""
                    : this.props.selectedItems[0].id
                }
              />
            ),
            key: "item6"
          },
          {
            onRender: this._onRenderItem,
            component: (
              <ConfirmDeleteDialog
                model="order"
                items={this.props.selectedItems}
              />
            ),
            key: "item7"
          },
          {
            onRender: this._onRenderItem,
            component: <ImportTransitDialog />,
            key: "item8"
          },
          {
            onRender: this._onRenderItem,
            component: <OrderTagButton items={this.props.selectedItems} />,
            key: "orderTagButton"
          },
          {
            onRender: this._onRenderItem,
            component: (
              <ReportToggleButton
                selectedItems={this.props.selectedItems}
                shipment={this.props.shipment}
                items={this.props.items}
              />
            ),
            key: "reportToggleButton"
          }
        ]}
      />
    );
  }
}

export default OrdersByShipmentTableCommandBar;



// WEBPACK FOOTER //
// ./src/views/Orders/Table/_OrdersByShipmentTableCommandBar.js